import {ajax} from '../modules/ajax';

var CommentsItem = class {
	constructor(wrapper, CommentsObj) {
		this._createElements(wrapper, CommentsObj);
        this._addEvents();
	}
	
	_createElements(wrapper, CommentsObj){
		this.wrapper = wrapper;
        this.CommentsObj = CommentsObj;
        this.param = JSON.parse(this.wrapper.getAttribute('data-param'));
        this.upBtn = this.wrapper.querySelector('[data-CommentsItem-up]');
        this.downBtn = this.wrapper.querySelector('[data-CommentsItem-down]');
        this.answerBtn = this.wrapper.querySelector('[data-CommentsItem-answerBtn]');
        this.replyToBtn = this.wrapper.querySelector('[data-CommentsItem-replyToBtn]');
        this.forForm = this.wrapper.querySelector('[data-CommentsItem-forForm]');
        this.numUp;
        this.numDown;
        this.voteAjaxPath = this._defineAjaxPath();
        this.isSending = false;
	}

    _defineAjaxPath(){
        var part = (window.location + '').indexOf('/_src/') === -1 ? '' : '/_src/layouts',
            path = part + '/' + this.CommentsObj.param.type + '/' + this.CommentsObj.param.uid + '/votecomment';

        return path;
    }

	_addEvents(){
        var self = this;

        if ( this.answerBtn ) {
            this.answerBtn.addEventListener('click', function(e){
                self._onClickAnswerBtn.call(self, e, 0);
            }, false);
        }

        if ( this.replyToBtn ) {
            this.replyToBtn.addEventListener('click', function(e){
                self._onClickReplyToBtn.call(self, e);
            }, false);
        }
        if ( this.upBtn ) {
            this.upBtn.addEventListener('click', function (e) {
                self._onClickVoteBtn.call(self, e, 1);
            }, false);
        }
        if ( this.downBtn ) {
            this.downBtn.addEventListener('click', function (e) {
                self._onClickVoteBtn.call(self, e, 0);
            }, false);
        }

	}

    _onClickAnswerBtn(e){
        e.preventDefault();

        if(!regAuthObj.isAuth){
            regAuthObj.authForm.showPopup();
            return false;
        }

        this.CommentsObj.moduleAll['CommentsForm'][0].onClickAnswerBtn(this);
    }

    _onClickReplyToBtn(e){
        e.preventDefault();
        var curTop = this.replyToBtn.getBoundingClientRect().top,
            uid = this.replyToBtn.getAttribute('data-CommentsItem-replyToBtn'),
            comment = document.getElementById(uid),
            commentTop = comment.getBoundingClientRect().top,
            delta = commentTop-curTop;

        //
        window.scrollBy(0, delta);
    }

    _onClickVoteBtn(e, vote){
        e.preventDefault();

        if(!regAuthObj.isAuth){
            regAuthObj.authForm.showPopup();
            return false;
        }

        if(this.isSending) return false;
        this.isSending = true;

        var self = this;
        ajax({
            data:{"vote":vote, "commentid":this.param.uid},
            url:this.voteAjaxPath,
            callback: function(msg){
                self._checkAnswer.call(self, msg);
            }
        });
    }

    _checkAnswer(msg){
        var msg = JSON.parse(msg);

        if (msg.auth === false){
            uPopup({
                content: 'Вам нужно авторизоваться повторно.',
                oncloseBefore: function () {
                    location.replace(location.protocol + '//' + location.host + location.pathname);
                }
            });
        }
        else if(!msg.status){
            uPopup({
                content: msg.message
            });
        }
        else {
            this._addVote(msg);
        }

        this.isSending = false;
    }

    _addVote(msg){
        var adCls = '',
            curCls = this.wrapper.className;

        adCls = msg.data.state == 'normal' ? '' : ' js-' + msg.data.state;
        adCls += msg.data.mark ? ' js-vote-' + msg.data.mark : '';

        if(!this.numUp){
            this.numUp = this.upBtn.querySelector('[data-CommentsItem-numUp]');
            this.numDown = this.downBtn.querySelector('[data-CommentsItem-numDown]');
        }

        this.numUp.innerHTML = msg.data.likes;
        this.numDown.innerHTML = msg.data.dislikes;
        this.wrapper.className = curCls.replace(/js-(low|high|vote-yes|vote-no)/g, '') + adCls;

        try {
            gtag('event', 'click', {
                'event_category': 'engagement',
                'event_label': 'comment_like_or_dislike'
            });
            console.log('gtag success!');
        } catch (error){
            console.error('gtag error:', error);
        }
    }

    del(){

    }
};

export {CommentsItem};





































